<a [class.active]="isActive" href="javascript:;" (click)="active = name">
  <ng-content></ng-content>
</a>